import { ApiClient } from 'ApiClient';

class DriverCashFlowService {
  public async saveDriverCashFlow(formData: any) {
    return ApiClient.post('driver-cash-flows', formData);
  }

  public getCashflowSum({
    dateFrom,
    dateTo,
  }: {
    dateFrom: string;
    dateTo: string;
  }): Promise<{sum:string}> {
    return ApiClient.get('driver-cash-flows', {
      dateFrom,
      dateTo,
    });
  }
}

const singleton = new DriverCashFlowService();

export { singleton as DriverCashFlowService };
